import { Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getPatientDetailsById } from 'app/api-ws/patients-ws';
import useAuth from 'app/hooks/useAuth';

function PatientData({ id }) {
  //   console.log('patientid', id[0].refPatientId);
  const {user} = useAuth()
  const [patientDetails, setPatientDetails] = useState([]);
  const fetchPatientDetails = () => {
    getPatientDetailsById(id[0]?.refPatientId, user.authToken)
      .then((res) => {
        setPatientDetails(res.data.patientData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchPatientDetails();
  }, []);

  // console.log('pdfPatientdet', patientDetails);

  return (
    <Grid item xs={6}>
      <Typography>
        <b>Billed To</b>
      </Typography>
      <Typography>{patientDetails?.patientName}</Typography>
      <Typography>{patientDetails?.address?.street}</Typography>
      <Typography>{patientDetails?.address?.locality}</Typography>
      <Typography>{patientDetails?.address?.district}</Typography>
      <Typography>{patientDetails?.phone}</Typography>
    </Grid>
  );
}

export default PatientData;
